import {ColDef} from 'ag-grid-community';

export const getCellClassName = (colDef?: ColDef) => (colDef?.wrapText ? undefined : 'ellipsis');
